import { useState } from 'react';
import { Placement } from 'react-bootstrap/Overlay';

import ELEMENT from 'common/element';
import { MenuItemConfig } from 'common/types';

import DropdownItems from 'components/common/DropdownItems/DropdownItems';
import OverlayTrigger from 'components/common/OverlayTrigger/OverlayTrigger';

import IconButton from './IconButton';

type IconMenuProps = {
  tooltip: string;
  icon: JSX.Element;
  sections: Array<Array<MenuItemConfig>>;
  onEntered?: () => void;
  placement?: Placement;
  testId: ELEMENT;
};

/**
 * OverlayTrigger that is using Icon as child
 *
 * @prop icon        The icon element
 * @prop tooltip     The tooltip message
 * @prop sections    List of menu item sections
 * @prop onEntered   Callback fired after the Overlay finishes transitioning in
 * @prop testId      Uniquely identifying string to use for testing
 */
const IconMenu = ({
  icon,
  tooltip,
  sections,
  onEntered = () => {},
  placement = 'bottom-start',
  testId,
}: IconMenuProps) => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <OverlayTrigger
      overlay={
        <div className="Dropdown__Menu">
          <DropdownItems close={() => setShowOverlay(false)} sections={sections} />
        </div>
      }
      placement={placement}
      showOverlay={showOverlay}
      setShowOverlay={setShowOverlay}
      onEntered={onEntered}
    >
      <IconButton tooltip={tooltip} showTooltip={!showOverlay} testId={testId} icon={icon} />
    </OverlayTrigger>
  );
};

export default IconMenu;
